import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { categories } from '../../../constants/category';
import 'swiper/components/pagination/pagination.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import SwiperCore, { Keyboard, Mousewheel, Pagination } from 'swiper';
import FoodCategory from '../molecule/FoodCategory';

SwiperCore.use([Pagination, Mousewheel, Keyboard]);

const FilterCategories: React.FC = () => {
  const category = Object.values(categories);
  const renderSlides = () => {
    const slides = [];
    for (let i = 0; i <= category.length / 6; i++) {
      slides.push(
        <SwiperSlide key={i}>
          <Flex alignItems={'center'} justify={'center'}>
            <Flex
              flexGrow={1}
              alignItems={'start'}
              justify={'space-evenly'}
              flexBasis={'33.3333%'}
              wrap={'wrap'}
              width={'100%'}
              maxW={'md'}
            >
              {category.slice(i * 6, (i + 1) * 6).map((item, index) => (
                <FoodCategory key={index} category={item} my={2} />
              ))}
            </Flex>
          </Flex>
        </SwiperSlide>,
      );
    }
    return slides;
  };
  return (
    <Box>
      <Swiper
        pagination={{
          clickable: true,
        }}
        mousewheel={true}
        keyboard={true}
        slidesPerView={1}
        initialSlide={0}
        style={{ paddingBottom: 30 }}
      >
        {renderSlides()}
      </Swiper>
    </Box>
  );
};

export default FilterCategories;
